import { InterviewDetail } from '@/api/request/oralInviteService' //简历详情接口
import { getRejectState, getReplyState, getJobInfo } from '@/api/request/concatService'
import emoji from '@/config/emoji'
import Vue from 'vue'
import { detailedTimesChange } from '@/utils/tool'

export let noArr = [ '6', '10', '80', '82', '83', '86', '91', '92', '93']
// 表示时间戳 缓存
let timesCache = {}
let judageCache = {}

/**
 * @description 删除多余的代码
  */
const removeMoreSet = (id, content, callback) => {
  // 判断缓存中是否有值
  if ( !judageCache[id] ) {
    // 设置数据
    callback()
    judageCache[id] = JSON.stringify(content)
    return
  }
  // 获取当前内容
  const currentContent = JSON.stringify(content)
  // 获取上次内容
  const preContent = judageCache[id]
  // 判断缓存中的值 是否一致
  if ( currentContent == preContent ) return
  // 执行函数
  callback()
  judageCache[id] = JSON.stringify(content)
}

// 计算是否应该显示 显示时间一行
export function computedTimerPoint() {
  // 表示不该显示的值
  return (langType) => {
    // 表示不该显示的值
    const noArr2 = [ '2', '3', '4', '5', '6', '80', '81', '82', '83', '86', '91', '92', '93','99', '200' ]
    return !noArr2.includes(langType)
  }
}

// 计算显示的时间
export function computedDispalyTime() {

  // 利用高阶函数 进行值得返回
  return (obj) => {

    // 判断对象中 是否包含time属性
    if ( !Reflect.has(obj, 'time') ) return ''

    // 判断缓存中是否有值
    if ( timesCache[obj.time] || timesCache[obj.time] == '' ) return timesCache[obj.time]

    // 解构数据
    let { currentTimeObj, currentNewTime, choosedUserId } = this
    // 获取当前活动用户id
    let activeId = choosedUserId
    // 表示当前激活的时间戳
    let activeTimes = currentNewTime[activeId]
    // 获取记录的时间戳
    let times = currentTimeObj[choosedUserId] || + new Date()
    if ( !currentTimeObj[choosedUserId] ) currentTimeObj[choosedUserId] = times

    // 判断记录的字符串是否小于  如果小于 认为就是历史记录
    if ( + obj.time < + times ) {

      timesCache[obj.time] = detailedTimesChange(obj.time)
      return timesCache[obj.time]
    }

    // 判断时间戳 是否有值 反之 就是第一次发送
    if ( !activeTimes ) {

      timesCache[obj.time] = detailedTimesChange(obj.time)
      currentNewTime[activeId] = + new Date()
      return timesCache[obj.time]
    }

    // 判断距离上次的距离 是否差5s  反之不显示
    if ( + new Date() - activeTimes >= 0 ) {

      timesCache[obj.time] = detailedTimesChange(obj.time)
      currentNewTime[activeId] = + new Date()
    } else {
      timesCache[obj.time] = ''
    }

    return timesCache[obj.time]
  }
}

// 根据时间戳 转换时分
export function timesChange(ptime) {

  const timeMaptting = {
    '1': '昨天',
    '2': '前天'
  }
  // 判断是否为空
  if ( !ptime || ptime == '' ) ptime = + new Date()
  const paramTime = new Date(typeof ptime == 'string' ? + ptime : ptime),
    hours = paramTime.getHours(),
    minutes = paramTime.getMinutes(),
    seconds = paramTime.getSeconds(),
    sum = hours * (60 * 60 * 1000) + minutes * (60 * 1000) + seconds * 1000,
    surplus = + new Date() - (+ paramTime - sum),
    padNum = (time, len = 2, val = '0') => (time + '').padStart(len, val),
    surDay = Math.floor(surplus / 86400000)
  if ( surDay >= 1 ) {
    return timeMaptting[surDay + ''] ? timeMaptting[surDay + ''] : `${ surDay }天前`
  }
  return `${ padNum(hours) }:${ padNum(minutes) }`
}

// 进行发送消息 计算 判断是否有表情
export function renderTxt() {
  return (txt = '') => {
    txt = txt.replace(/<.*?>/g, '')
    // 文本数组
    let rnTxt = []
    let match = null
    // 判断表情的正则表达式
    const regex = /(\[.*?\])/g
    let start = 0
    let index = 0
    while ( (match = regex.exec(txt)) ) {
      index = match.index
      if ( index > start ) {
        rnTxt.push(txt.substring(start, index))
      }
      if ( match[1] in emoji.obj ) {
        const v = emoji.obj[match[1]]
        rnTxt.push(customEmoji(v))
      } else {
        rnTxt.push(match[1])
      }
      start = index + match[1].length
    }
    rnTxt.push(txt.substring(start, txt.length))
    return rnTxt.toString().replace(/,/g, '')
  }
}

// 表示所有的表情
// value 表示表情
function customEmoji(value) {
  return `<img data-img = ${ value.split('.')[0] } src="../../../../../static/faces/${ value }" style="width:20px"/>`
}

// 计算用户头像
export function userHead() {
  // 参数bySelf 为true 用户自己头像  反之聊天人的头像
  return (bySelf = true) => {

    let gril_default = this.gril_default
    let head = gril_default
    // 判断是用户自己的 还是他人的
    if ( bySelf ) {

      // 获取用户信息
      let userInfo = localStorage.getItem('userInfo')
      // 判断用户信息是否为空
      if ( !userInfo || userInfo == '' ) return head

      // 判断是否有头像
      userInfo = JSON.parse(userInfo)
      return !userInfo['headImg'] || userInfo['headImg'] == '' ?
        head : userInfo['headImg']
    } else {

      // 获取聊天用户id
      let id = localStorage.getItem('currentId')
      // 进行遍历
      this.concatUserList.forEach(item => item.name == id ? head = item.headImg : '')

      return !head || head == '' ? gril_default : head
    }
  }
}

/**
 * @author lihh
 * @description 表示企业线上线下面试
 */
export function computeInter() {
  const interDataFormat = (datas) => {
    let {
      companyName,
      interviewContact,
      interviewAddress,
      positionName,
      remarks,
      interviewType,
      interviewTime,
      interviewTelephoneCode,
      noInterview,
      status
    } = datas
    let times = interviewTime.substring(0, 16)
    let links = interviewContact + ' ' + interviewTelephoneCode
    let params = {
      companyName,
      links,
      interviewAddress,
      positionName,
      remarks,
      interviewType,
      times,
      noInterview,
      status
    }
    return params
  }
  return ({ inviteId }) => {
    if ( this.resInter[inviteId] && this.resInter[inviteId].noInterview != 0 ) return
    InterviewDetail(inviteId).then(res => {
      if ( res.code != 200 || res.data == null ) return
      let interDetail = interDataFormat(res.data)
      removeMoreSet(inviteId, interDetail, () => Vue.set(this.resInter, inviteId, interDetail))
    })
  }
}

// 计算初次聊天卡片详情

export function computeJobs() {

  const interDataFormat = (datas) => {
    datas = this.$CommonUtil._updateMoneyFormat(datas)
    let {
      city,
      companyName,
      education,
      positionName,
      professionalCategory,
      recruitType,
      recruitingOb,
      newSalary
    } = datas

    let params = {
      city,
      companyName,
      education,
      positionName,
      professionalCategory,
      recruitType,
      recruitingOb,
      newSalary
    }

    return params
  }

  return (jobId) => {
    // 1.判断缓存中是否存在
    if ( this.resJobDetail[jobId] ) return ''
    getJobInfo(jobId).then(res => {
      // console.log(res)
      if ( res.code != 200 || res.data == null ) return false
      // 数据格式化
      let interDetail = interDataFormat(res.data)
      removeMoreSet(jobId, interDetail, () => Vue.set(this.resJobDetail, jobId, interDetail))
    })
  }
}

/**
 * @author lihh
 * @description 计算是否同意请求
 */
export function computeRejectState() {
  return (content) => {
    let { msg: id } = content
    if ( id.indexOf('###') !== - 1 ) {
      const ids = id.split('###')
      id = ids[ids.length - 1]
    }
    if ( this.rejectStateList[id] && this.rejectStateList[id] != 1 ) return

    getRejectState({ id }).then(res => {
      if ( res.code != 200 ) {
        return
      }
      removeMoreSet(id, res.data, () => Vue.set(this.rejectStateList, id, res.data))
    })
  }
}

/**
 * @author lihh
 * @description 算附件、邀请投递请求的同意拒绝状态
 */
export function computeAttState() {
  return (id) => {
    if ( this.AttStateList[id] && this.AttStateList[id] != 1 ) return
    getReplyState({ id }).then(res => {
      if ( res.code != 200 ) {
        return
      }
      removeMoreSet(id, res.data, () => Vue.set(this.AttStateList, id, res.data))
    })
  }
}

/**
 * @description 计算邀请进群请求状态
 */
export function computeChatState() {
  return (item) => {
    // 解构数据
    const { msg: ids } = item
    let id = ids.split('&')[2]
    // 若!=1，则是已经做出选择，便不需要再次请求
    if ( this.chatStateList[id] && this.chatStateList[id] != 1 ) return
    getReplyState({ id }).then(res => {
      // 判断请求成功
      if ( res.code != 200 ) {
        return
      }
      // 1表示待接受  2表示接受  3拒绝
      removeMoreSet(id, res.data, () => Vue.set(this.chatStateList, id, res.data))
    })
  }
}

// 计算沟通职位
export function compuedPosName() {
  // 判断是否有职位
  if ( this.allJobInfo.length == 0 || this.choosedUserId == '' ) return '暂无职位'

  const activeItem = this.allJobInfo.filter(item => item.id == this.choosedConcatJobId)
  if (activeItem.length) {
    this.activeJobType = activeItem[0].recruitType == 1 ? 0 : 1
  }
  return !activeItem || activeItem.length == 0 ? '未选择职位' : activeItem[0]['name']
}

// 计算正在沟通的职位是否过期 true 过期 false 不过期
export function compuedPosState() {
  // 判断是否有职位
  if ( this.allJobInfo.length == 0 || this.choosedUserId == '' ) return '暂无职位'
  const activeItem = this.allJobInfo.filter(item => item.id == this.choosedConcatJobId)
  return !activeItem || activeItem.length == 0 ? false : activeItem[0].state == 2 ? true : false
}

// 计算用户头像
export function userListHead() {
  return (url) => {
    // 判断url是否是正常路径  反之就是默认头像
    if ( url != null && url.startsWith('http') ) {
      return url
    }
    return this[url] ? this[url] : this.avatar
  }
}

/**
 * @description 表示清除局部状态
 */
export function clearPartStatus() {
  judageCache = {}
}



// WEBPACK FOOTER //
// ./src/components/MessageManage/components/methods/computed.js